var bind = require('./util/bind');
var defaultUrl = 'https://tp.qunar.com/touch/touchCashier?';

module.exports = function (config) {
    var sdk = this;
    var cashierHandle = function cashierHandle(options) {
        var cashierUrl = options.url ? options.url + '?' : defaultUrl;
        Object.keys(options).forEach(function (v) {
            if (['success', 'fail', 'url'].indexOf(v) === -1) {
                cashierUrl += v + '=' + options[v] + '&';
            }
        });
        location.href = cashierUrl.replace(/&$/g, '');
    };

    var api = {
        /**
         * 调用收银台<br />
         * @method hysdk.openCashier
         * @category Qunar
         * @example ./openCashier.js[1-20]
         * @description
         *
         * **在携程客户端内使用携程支付逻辑**
         *
         * | 运行环境 | 是否支持 |
         * | :-----: | :-----: |
         * | Hy      |   √   |
         * | Hy Browser (qunar) | √    |
         * | Hy Browser (非qunar) | √    |
         * | touch   |   √  |
         * | wechat  |   √   |
         * | ctrip   |   √   |
         *
         * 参考：<a href="http://wiki.corp.qunar.com/pages/viewpage.action?pageId=43255424" target="_blank">Touch收银台获取token接口</a>，<a href="http://wiki.corp.qunar.com/pages/viewpage.action?pageId=92343298" target="_blank">hybrid收银台</a>
         */
        openCashier: {
            hy: {
                key: 'hbCashier'
            },
            wechat: {
                handle: cashierHandle
            },
            h5: {
                handle: cashierHandle
            }
        }
    };

    bind(sdk, api, config);
};


//////////////////
// WEBPACK FOOTER
// ../plugins/qunar/cashier.js
// module id = 38
// module chunks = 1 3 4